import { Component, OnInit, Output, EventEmitter, Input, HostListener, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorHandlerService } from '@aveva/connect-web-core';
import { AssignCdsCC } from 'src/app/models/assign.model';
import * as globals from '../../globals';
import { AssignmentsService } from 'src/app/services/assignments.service';
import { LoggingService } from '../../../services/logging.service';

@Component({
  standalone: false,
  selector: 'app-assign-cds-accesstoken',
  templateUrl: './assign-cds-accesstoken.component.html',
  styleUrls: ['./assign-cds-accesstoken.component.scss']
})
export class AssignCdsAccesstokenComponent {

  constructor(
    private errorHandler: ErrorHandlerService,
    private assignmentService: AssignmentsService,
    private snackBar: MatSnackBar,
    private logger: LoggingService) { }

  create() {
    this.loadingSpinner.emit(true);
    
    if (this.submitting) {
      return;
    }

    this.submitting = true;
    
    try {
      if(this.assign.client_id == null) {
        this.assign.client_id = '';
      }

      if(this.assign.client_secret == null) {
        this.assign.client_secret = '';
      }

      this.assignmentService.updateAssignment(this.assign).subscribe({
        next: (data) => {
          this.form.resetForm();
          this.loadingSpinner.emit(false);
          this.displaySnackBar(globals.assignment_success);
          this.saved.emit(data);
        },
        error: (e) => {
          this.logger.logException(e);
          this.loadingSpinner.emit(false);
          this.displaySnackBar(globals.assignment_failed);
        }
      });

    } catch (error) {
      this.logger.logException(error);
      if (error.status === 409) {
        this.form.controls['name'].setErrors({ 'notUnique': true });
      } else if (error.error?.statusCode === 400 && error.error?.errorCode === globals.RESOURCELIMIT) {
        this.errorHandler.handle(error.error, globals.CLASS_LIMIT_REACHED);
      } else {
        return this.errorHandler.handle(error);
      }
    }
    finally {
      this.submitting = false;
    }
  }  

  cancel = () => this.cancelled.emit();

  close = () => this.cancelled.emit();
  
  displaySnackBar = (message: string) => this.snackBar.open(message, null, {duration: 5000});

  submitting = false;

  @Input() assign: AssignCdsCC = new AssignCdsCC();
  @Output() saved: EventEmitter<any> = new EventEmitter();
  @Output() cancelled: EventEmitter<any> = new EventEmitter();
  @Output() loadingSpinner: EventEmitter<boolean> = new EventEmitter();
  @ViewChild('form', { static: true }) form: NgForm;

  @HostListener('window:beforeunload')
  canDeactivate = (): boolean => !this.form.dirty || this.form.submitted;
}
